import React, { useContext } from "react";
import cn from "classnames";
import {
    about,
    aboutUA,
    myBioInfo,
    textAboutMe,
    textAboutMeUA,
} from "../../data/bioInfo";

import styles from "./About.module.css";
import baseStyle from "../components.module.css";
import Bio from "./Bio";
import LanguageContext from "../context/LanguageContext";

export default function About({ className, active, toAboutRef }) {
    const { language } = useContext(LanguageContext);

    return (
        <div
            className={cn(className, {
                [baseStyle.fadeInLeft]: active === "about",
            })}
            ref={toAboutRef}
        >
            <div className={baseStyle.topField}></div>
            <div className={cn(baseStyle.wrapper)}>
                <h2 className={cn(baseStyle.title)}>
                    {language === "en" ? about : aboutUA}
                </h2>

                <div className={cn(styles.aboutMeBlock)}>
                    <div className={cn(styles.story)}>
                        {(language === "en" ? textAboutMe : textAboutMeUA).map(
                            (text) => (
                                <p key={text}>{text}</p>
                            )
                        )}
                    </div>
                    <Bio myBioInfo={myBioInfo} dots=" . . . ." />
                </div>
            </div>
            <div className={baseStyle.bottomField}></div>
        </div>
    );
}
